import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import toast, { Toaster } from "react-hot-toast";

const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      toast.error("Email Field empty");
    }

    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!re.test(String(email).toLowerCase())) {
      toast.error("Invalid EmailID");
    }

    axios({
      method: "post",
      url: "https://misty-personal-assistant.herokuapp.com/api/auth/login",
      data: {
        email,
        password,
      },
    }).then((result) => {
      if (result.data.success) {
        auth.login(result.data.user, result.data.token);
        navigate("/home");
      } else {
        toast.error(result.data.data);
      }
    });
  };

  return (
    <div className="login">
      <div className="background">
        {/* <div className="shape"></div>
        <div className="shape"></div> */}
      </div>
      <center style={{ marginTop: "2rem" }}>
        <h1>Welcome to MISTY, your personal assistant! </h1>
      </center>
      <form onSubmit={handleFormSubmit}>
        <h2>Login</h2>
        <div>
          <label for="username">Email</label>
          <input
            placeholder="Enter email"
            type="text"
            onChange={(e) => setEmail(e.target.value)}
          ></input>
        </div>
        <div>
          <label for="username">Password</label>
          <input
            placeholder="Password"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
          ></input>
        </div>

        <button type="submit" style={{ padding: "0.3rem" }}>
          Login
        </button>
        <div className="signup" style={{ marginTop: "1rem" }}>
          <p>
            Not registered?{" "}
            <a href="/register" style={{ color: "#bbf247" }}>
              Signup
            </a>
          </p>
        </div>
      </form>
      {/* not registered signup */}
    </div>
  );
};

export default Login;
